// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 620 ? "pdfjsWorker" : chunkId) + "." + {"239":"d53665d3","455":"1ee1175b","620":"e898ae61","977":"ce6c5112"}[chunkId] + ".chunk.js";
};